import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NovedadComercial } from '../../services/novedades-comerciales.service';

@Component({
  selector: 'app-detalle-novedad-dialog',
  templateUrl: './detalle-novedad-dialog.component.html',
  styleUrls: ['./detalle-novedad-dialog.component.scss']
})
export class DetalleNovedadDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: {
    novedad: NovedadComercial,
    tipoNovedadDescripcion: string,
    vendedorNombre: string
  }) { }
}
